import {clientsClaim as workbox_core_clientsClaim} from '/Volumes/Extreme Pro/projects/morrenhof-jansen-2024/wp-content/themes/pe-morrenhof-jansen-2024/library/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/Volumes/Extreme Pro/projects/morrenhof-jansen-2024/wp-content/themes/pe-morrenhof-jansen-2024/library/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "library/build/appimg/icons.eefcbbbc.svg",
    "revision": "a7f93d969c6cf921b4a8236c06f4a031"
  },
  {
    "url": "library/build/appmain.00b6dbef.css",
    "revision": null
  },
  {
    "url": "library/build/appmain.0f1cc882.js",
    "revision": null
  },
  {
    "url": "library/build/appmain.0f1cc882.js.LICENSE.txt",
    "revision": "d59d9b5d43b6905d3b20c6da78d7dd72"
  }
], {});








